class CaseStudyModel {
  constructor(data) {
    this.id = data.id || "";
    this.title = data.title || "";
    this.text = data.text || "";
    this.link = data.link || "";
    this.linkText = data.linkText || "";
    this.solutionId = data.solutionId || "";
    this.sectorialSolutionId = data.sectorialSolutionId || "";
    this.image = data.image || "";
  }

  /**
   * Generate case study card
   *
   * @returns {string} html in string format
   */
  generateCaseStudyCard() {
    return `<div 
                class="categoryWrapper categoryWrapper--financial" 
                data-solution-id="${this.solutionId}"
                data-sectorial-solution-id="${this.sectorialSolutionId}"
            >
                <button class="btn-border-transition">
                    <span>
                        <span>
                        <div class="box_include_item_relate box_include_item_relate--financial">
                            <div class="box_img_top">
                                <img src="${this.image}" alt="" />
                            </div>
                            <div class="box_includes_list">
                                <h2 class="head_secundary_title--bold">${this.title}</h2>
                                <p class="primary_content_paragraph box_case_studie_item--left">
                                ${this.text}
                                </p>
                            </div>
                            <div class="box_button_read--more">
                                <a href="${this.link}" target=”_blank” >
                                    <span>${this.linkText}</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3"
                                    stroke="currentColor" class="w-6 h-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                                    </svg>
                                </a>
                            </div>
                        </div>
                        </span>
                    </span>
                </button>
            </div>`;
  }
}

export default CaseStudyModel;
